
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_631_719)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_631_719)"}},[_c('path',{attrs:{"d":"M23.38 12.233c0-.863-.07-1.493-.225-2.147h-10.06v3.897H19c-.12.968-.762 2.427-2.19 3.407l-.02.13 3.18 2.415.22.021c2.024-1.831 3.19-4.526 3.19-7.723z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M13.094 22.5c2.893 0 5.321-.933 7.095-2.543l-3.38-2.567c-.906.618-2.12 1.05-3.715 1.05a6.438 6.438 0 01-6.095-4.363l-.126.01-3.307 2.509-.044.117c1.762 3.43 5.381 5.787 9.572 5.787z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M7 14.077A6.348 6.348 0 016.643 12c0-.723.131-1.423.345-2.076l-.006-.14-3.348-2.548-.11.05A10.339 10.339 0 002.381 12c0 1.692.417 3.29 1.143 4.713L7 14.078z","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M13.094 5.56c2.012 0 3.369.852 4.143 1.563L20.26 4.23c-1.857-1.692-4.274-2.73-7.167-2.73-4.19 0-7.81 2.357-9.572 5.787l3.465 2.636a6.465 6.465 0 016.107-4.363z","fill":"#EB4335"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_631_719"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.88)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_631_719"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.88)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    